/**
 * Configuración del cupón de lanzamiento.
 * Se muestra cuando REACT_APP_SHOW_LAUNCH_COUPON está definido y es "true".
 */
const showLaunchCoupon =
	typeof process.env.REACT_APP_SHOW_LAUNCH_COUPON !== "undefined" &&
	String(process.env.REACT_APP_SHOW_LAUNCH_COUPON).toLowerCase() === "true";

export const LAUNCH_COUPON = {
	show: showLaunchCoupon,
	code: "LANZAMIENTO",
	discountEur: 20,
	subscriptionPriceEur: 49.99,
	get priceAfterDiscount() {
		return Math.max(0, this.subscriptionPriceEur - this.discountEur);
	},
};
